import * as vp from 'vopay';
import { useEffect, FC, useState } from 'react';
import useFetchACHWithdrawTransaction from '@/hooks/useApi/useFetchACHWithdrawTransaction';
import AchWithdrawalTransactionInfo from './ACHWithdrawalTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

const { TransactionType } = vp;

type AchWithdrawalTransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
  ELinxRequestID?: string;
};

const AchWithdrawalTransactionContainer: FC<AchWithdrawalTransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
}) => {
  const { userSettings } = useUserSettingsProvider();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.ACHWithdrawTransactionResponse>();
  const [achWithdrawalTransaction, getAchWithdrawTransaction, resetTransactionsId] = useFetchACHWithdrawTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    getAchWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (achWithdrawalTransaction) {
      setTransaction(achWithdrawalTransaction);
    }
  }, [achWithdrawalTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  const fundingParentTransaction = Object.values(transaction?.ParentTransaction || {}).find(
    (parent) => parent.TransactionType === TransactionType.ACH_FUNDING,
  );

  return (
    <div>
      {transaction && (
        <AchWithdrawalTransactionInfo
          transaction={transaction}
          Notes={Notes}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          parentTransactionId={fundingParentTransaction?.TransactionID}
          parentType={fundingParentTransaction ? 'ACH Funding' : undefined}
        />
      )}
    </div>
  );
};

export default AchWithdrawalTransactionContainer;
